import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class PreloaderService {
  private isPreloaderVisibleSubject: BehaviorSubject<boolean> = new BehaviorSubject(false);
  private preloaderProgressSubject: BehaviorSubject<number> = new BehaviorSubject(0);

  isPreloaderVisible$: Observable<boolean> = this.isPreloaderVisibleSubject.asObservable();
  preloaderProgress$: Observable<number> = this.preloaderProgressSubject.asObservable();

  constructor() {}

  updatePreloaderProgress(value: number): void {
    this.preloaderProgressSubject.next(value);
  }

  showPreloader(): void {
    this.isPreloaderVisibleSubject.next(true);
  }

  hidePreloader(): void {
    this.isPreloaderVisibleSubject.next(false);
  }
}
